module.exports = __webpack_public_path__ + "img/huiyuan.ae849a65.png";